__turbopack_context__.v({
  "className": "exposure_63bc633d-module__ao5eza__className",
  "variable": "exposure_63bc633d-module__ao5eza__variable",
});
